import { Validator } from '@vista-digital/validator';
import { cdnStandardAssetOptionsValidator } from '../../../../validators/cdn-asset-options';
/**
 * Default Member Card component CDN options.
 */
export const defaultMemberCardCdnOptions = {
    clubLogo: { height: 50 },
    subscriptionLogo: { height: 50 }
};
/**
 * Validator for the Member Card component CDN options.
 */
export const memberCardCdnOptionsValidator = Validator.object({
    clubLogo: cdnStandardAssetOptionsValidator,
    subscriptionLogo: cdnStandardAssetOptionsValidator
});
